import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import { I18nHoc, Trans } from 'helpers/i18n';
import Row, { Col } from 'components/row';

import logoBildControl from 'src-sites/bildcontrol/assets/bc.svg';

import translates from '../about-i18n.json';

const classes = new Bem('blockDescription');

@I18nHoc(translates)
export default class DescriptionBlock extends Component {
  static propTypes = {
    className: PropTypes.string
  };

  render() {
    const { className } = this.props;

    return (
      <div {...classes({ extra: className })}>
        <Trans lang="ru">
          <Row {...classes('row', 'block')} mpColumn>
            <Col {...classes('col', 'img')} allPr={0}>
              <div {...classes('imgContainer')}>
                <img {...classes('img')} src={logoBildControl} alt="логотип bildcontrol.ua" loading="lazy" decoding="async" />
              </div>
              <div {...classes('text', 'h2')}><h2 children="Полезный или провокативный?" /></div>
            </Col>
            <Col {...classes('col', 'info')} allPr={0}>
              <div {...classes('topic')}>
                <p {...classes('text')} children="Наш выбор — правдивая и независимая оценка." />
                <span {...classes('separator')} />
              </div>
              <div {...classes('description')}>
                <p {...classes('text')} children="На количество баллов не влияет ни известность бренда, ни сотрудничество в рамках рекламной кампании на других наших ресурсах. Дополнительные баллы нельзя купить." />
              </div>
            </Col>
            <Col {...classes('col', 'info')} allPr={0}>
              <div {...classes('topic')}>
                <p {...classes('text')} children="Мы понимаем, что подвергаем себя риску, работая над таким проектом." />
                <span {...classes('separator')} />
              </div>
              <div {...classes('description')}>
                <p {...classes('text')} children="Возможна ситуация, когда застройщики, чьи комплексы получили низкую оценку, будут пытаться закрыть наш проект, испортить репутацию ресурса. Такие действия лишь докажут, что индекс надёжности работает и важен для инвесторов." />
              </div>
            </Col>
            <Col {...classes('col', 'info')} allPr={0}>
              <div {...classes('topic')}>
                <p {...classes('text')} children="Конечная цель проекта — мотивировать застройщиков Украины к честной и открытой деятельности с акцентом на качество, заботу об инвесторах и высокую репутацию." />
                <span {...classes('separator')} />
              </div>
            </Col>
          </Row>
        </Trans>
        <Trans lang="ua">
          <Row {...classes('row', 'block')} mpColumn>
            <Col {...classes('col', 'img')} allPr={0}>
              <div {...classes('imgContainer')}>
                <img {...classes('img')} src={logoBildControl} alt="логотип bildcontrol.ua" loading="lazy" decoding="async" />
              </div>
              <div {...classes('text', 'h2')}><h2 children="Корисний або провокаційний?" /></div>
            </Col>
            <Col {...classes('col', 'info')} allPr={0}>
              <div {...classes('topic')}>
                <p {...classes('text')} children="Наш вибір — правдива і незалежна оцінка." />
                <span {...classes('separator')} />
              </div>
              <div {...classes('description')}>
                <p {...classes('text')} children="На кількість балів не впливає ні популярність бренду, ні співробітництво в рамках рекламної кампанії на інших наших ресурсах. Додаткові бали купити неможливо." />
              </div>
            </Col>
            <Col {...classes('col', 'info')} allPr={0}>
              <div {...classes('topic')}>
                <p {...classes('text')} children="Ми розуміємо, що піддаємо себе ризику, працюючи над таким проєктом." />
                <span {...classes('separator')} />
              </div>
              <div {...classes('description')}>
                <p {...classes('text')} children="Можлива ситуація, коли забудовники, чиї комплекси отримали низьку оцінку, будуть намагатися закрити наш проєкт, зіпсувати репутацію ресурсу. Такі дії лише доведуть, що індекс надійності працює і важливий для інвесторів." />
              </div>
            </Col>
            <Col {...classes('col', 'info')} allPr={0}>
              <div {...classes('topic')}>
                <p {...classes('text')} children="Кінцева мета проєкту — мотивувати забудовників України до чесної і відкритої діяльності з акцентом на якість, турботу про інвесторів і високу репутацію." />
                <span {...classes('separator')} />
              </div>
            </Col>
          </Row>
        </Trans>
      </div>
    );
  }
}
